import { ChangeDetectorRef,Component, ElementRef, Input, OnInit, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { ComponentBase, T4DataSource } from 't4core';
import { RequestDetails, ServiceRequestStatus } from 't4core';
import { T4_FindIssueDialog } from '../../dialogs/findIssueDialog/findIssueDialog';
import { T4_ServiceDialog } from '../../dialogs/serviceDialog/serviceDialog';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import * as moment from 'moment';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
    selector: 'InsuranceCasesOverview',
    templateUrl: './Insurance.html',
    styleUrls: ['./Insurance.css']
})
export class InsuranceCasesOverview extends ComponentBase implements OnInit {
    @Input() public isOneWay: boolean = false;

    @ViewChild("newIssues") datatable: T4DatatableWidget;
    @ViewChild("urgentIssues") urgentIssues: T4DatatableWidget;

    @ViewChild("handledIssues") handledIssues: T4DatatableWidget;
    @ViewChild("activeIssues") activeIssues: T4DatatableWidget;
    @ViewChild("completedIssues") completedIssues: T4DatatableWidget;

  @ViewChild("incompleteIssues") incompleteIssues: T4DatatableWidget;

    @ViewChildren(MatSort) ctrlSorters: QueryList<MatSort>;
    @ViewChildren(MatPaginator) ctrlPagers: QueryList<MatPaginator>;

    private sorters: MatSort[] = [];
    private pagers: MatPaginator[] = [];

    public txtFilter: FormControl = new FormControl();

    public filterText: string = "";

    public displayCompleted: boolean = false;

    public urgentInsuranceCases: RequestDetails[];
    public newInsuranceRequests: RequestDetails[];
    public handledInsuranceRequests: RequestDetails[];
    public activeInsuranceRequests: RequestDetails[];
    public incompleteInsuranceRequests: RequestDetails[];
    public completedInsuranceRequests: RequestDetails[];

    public filteredUrgentInsuranceCases: RequestDetails[];
    public filteredNewInsuranceRequests: RequestDetails[];
    public filteredHandledInsuranceRequests: RequestDetails[];
    public filteredActiveInsuranceRequests: RequestDetails[];
    public filteredIncompleteInsuranceRequests: RequestDetails[];
    public filteredCompletedInsuranceRequests: RequestDetails[];

    public owners: string[];
    groupsControl = new FormControl([]);

    tblAllColumns = ['userId', 'InsuranceId', 'CreatedAt', 'RentalObject', 'RentalLocation', 'Description'];
    tblFeaturedColumns = ['userId', 'InsuranceId', 'EstimatedDate', 'Status', 'RentalObject', 'RentalLocation', 'ServiceLocation'];
    tblNewColumns = ['userId', 'InsuranceId', 'CreatedAt', 'RentalObject', 'RentalLocation', 'Description'];
    tblActiveColumns = ['userId', 'InsuranceId', 'EstimatedDate', 'Status', 'RentalObject', 'RentalLocation', 'ServiceLocation'];
    tblExpiredColumns = ['userId', 'InsuranceId', 'RentalObject', 'RentalLocation', 'ServiceLocation'];
    tblMissingColumns = ['userId', 'InsuranceId', 'RentalObject', 'CreatedAt', 'RentalLocation'];

    constructor(private router: Router, private route: ActivatedRoute, el: ElementRef, private changeDetectorRef: ChangeDetectorRef) {
        super();

        //this.txtFilter.valueChanges.pipe(debounceTime(150))
        //    .subscribe(() => {
        //        if (this.featuredRequests) this.featuredRequests.filter = this.txtFilter.value;
        //        if (this.newRequests) this.newRequests.filter = this.txtFilter.value;
        //        if (this.activeRequests) this.activeRequests.filter = this.txtFilter.value;
        //        if (this.expiredRequests) this.expiredRequests.filter = this.txtFilter.value;
        //        if (this.missingRequests) this.missingRequests.filter = this.txtFilter.value;
        //    });
    }

    async ngOnInit() {

        await this.populateDatasources();
        await this.createFilterOptions();
      //this.loadRequests();

      var transform = {
        ObjectLocation: (x) => x.ObjectLocation.Name,
        ServiceLocation: x => x.ServiceLocation?.Name,
        RentalObject: x => x.RentalObject?.Title,
      };

      this.datatable.exportTransformations = transform;
      this.urgentIssues.exportTransformations = transform;
      this.handledIssues.exportTransformations = transform;
      this.activeIssues.exportTransformations = transform;
      this.completedIssues.exportTransformations = transform;
      this.incompleteIssues.exportTransformations = transform;
    }

    private async populateDatasources() {
        var token = this.UI.beginLoading('Turbo.OneWayAdmin.Insurance.msgLoadingRequest', 'Loading insurance requests', null);
        this.urgentInsuranceCases = await this.Api.get<any[]>("Service/GetUrgentInsuranceRequests");
        this.newInsuranceRequests = await this.Api.get<any[]>("Service/GetNewInsuranceRequests");
        this.handledInsuranceRequests = await this.Api.get<any[]>("Service/GetHandledInsuranceRequests");
        this.activeInsuranceRequests = await this.Api.get<any[]>("Service/GetActiveInsuranceRequests");
        this.incompleteInsuranceRequests = await this.Api.get<any[]>("Service/GetIncompleteInsuranceRequests");
        this.completedInsuranceRequests = await this.Api.get<any[]>("Service/GetCompletedInsuranceRequests");
        this.UI.loaderCompleted(token);
    }

    public async createFilterOptions() {
      this.owners = await this.Api.get<string[]>("RentalObjectService/GetSelectOwners")
      this.applyFilter();
    }

    applyFilter() {
        var token = this.UI.beginLoading('Turbo.OneWayAdmin.Insurance.msgLoadingRequest', 'Loading insurance requests', null);
        const selectedOwners = this.groupsControl.value;// Get the selected values from the FormControl
        this.filteredUrgentInsuranceCases = this.filterData(selectedOwners, this.urgentInsuranceCases);
        this.filteredNewInsuranceRequests = this.filterData(selectedOwners, this.newInsuranceRequests);
        this.filteredHandledInsuranceRequests = this.filterData(selectedOwners, this.handledInsuranceRequests);
        this.filteredActiveInsuranceRequests = this.filterData(selectedOwners, this.activeInsuranceRequests);
        this.filteredIncompleteInsuranceRequests = this.filterData(selectedOwners, this.incompleteInsuranceRequests);
        this.filteredCompletedInsuranceRequests = this.filterData(selectedOwners, this.completedInsuranceRequests);
        this.changeDetectorRef.detectChanges();
        this.UI.loaderCompleted(token);
    }

    filterData(selectedOwners: string[], insuranceCases: RequestDetails[]): RequestDetails[] {
      if (selectedOwners.length === 0) return insuranceCases;
      return insuranceCases.filter(item => selectedOwners.some(o => o === item.Owner));
    }
    // Data
    //private requests: RequestDetails[] = [];
    //private Completedrequests: RequestDetails[] = [];

    // ViewModel
    //public damagedRequests: T4DataSource;
    //public completedRequests: T4DataSource;

    //public allRequests: T4DataSource;
    //public newRequests: T4DataSource;
    //public featuredRequests: T4DataSource;
    //public activeRequests: T4DataSource;
    //public expiredRequests: T4DataSource;
    //public missingRequests: T4DataSource;

    // Event handlers
    public FindIssue() {
      this.Dialog.open(T4_FindIssueDialog).afterClosed().toPromise().then((x: RequestDetails) => {
            if (x) {
                this.Dialog.open(T4_ServiceDialog, { data: { requestId: x.Id } }).afterClosed().toPromise().then((x: any) => { });
            }
        });
    }
    // Data functions
    //private async loadRequests() {
    //    var token = this.UI.beginLoading('Turbo.OneWayAdmin.Service.msgLoadingRequest', 'Loading service requests', null);

    //    this.Api.get<RequestDetails[]>('/Service/GetInsuranceRequests', { oneway: false }).then(x => {
    //        this.requests = x;

    //        this.sorters = this.ctrlSorters.toArray();
    //        this.pagers = this.ctrlPagers.toArray();

    //        this.populateDatasources();

    //        if (this.Settings.isInAny(['OneWayAdmin'])) {
    //            this.sorters[0].sort({ id: "CreatedAt", start: "asc", disableClear: false });
    //            this.sorters[1].sort({ id: "New", start: "asc", disableClear: false });
    //            //this.sorters[2].sort({ id: "New2", start: "asc", disableClear: false });
    //        }
    //        else {
    //            this.sorters[0].sort({ id: "New3", start: "asc", disableClear: false });
    //        }

    //        this.UI.loaderCompleted(token);
    //    });
    //}

    //private populateDatasources() {

    //    var today: moment.Moment = moment();

    //    if (this.Settings.isInAny(['OneWayAdmin'])) {
    //        this.newRequests = new T4DataSource(this.requests.slice().filter(x => x.Status! < ServiceRequestStatus.Received || (x.Status! >= ServiceRequestStatus.Received && x.Status! < ServiceRequestStatus.Completed && x.ExpectedResolveDate && x.ExpectedResolveDate >= today)), this.sorters[0], this.pagers[0], "New requests", this.assembleSearchString);
    //        this.featuredRequests = new T4DataSource(this.requests.slice().filter(x => x.Status! >= ServiceRequestStatus.Received && x.Status! < ServiceRequestStatus.Completed && (!x.ExpectedResolveDate || x.ExpectedResolveDate < today)), this.sorters[1], this.pagers[1], "Featured requests", this.assembleSearchString);
    //        //this.completedRequests = new T4DataSource(this.requests.slice().filter(x => x.Status! == ServiceRequestStatus.Completed), this.sorters[2], this.pagers[2], "Featured requests", this.assembleSearchString);
    //    }
    //    else {
    //        this.activeRequests = new T4DataSource(this.requests.slice().filter(x => x.Status! < ServiceRequestStatus.Completed), this.sorters[0], this.pagers[0], "All requests", this.assembleSearchString);
    //    }
    //}

    //private updateRequest(id: string) {
    //    var token = this.UI.beginLoading('Turbo.OneWayAdmin.Service.msgLoadingRequest', 'Loading service requests', null);

    //    this.Api.get<RequestDetails>('/Service/GetRequest', { id: id }).then(x => {
    //        var item = this.requests.find(y => y.Id == x.Id);
    //        if (!item) return;

    //        this.requests.splice(this.requests.indexOf(item), 1);
    //        this.requests[this.requests.indexOf(item)] = x;
    //        this.requests.push(x);

    //        this.populateDatasources();

    //        // Set filter
    //        if (this.featuredRequests) this.featuredRequests.filter = this.txtFilter.value;
    //        if (this.newRequests) this.newRequests.filter = this.txtFilter.value;
    //        if (this.activeRequests) this.activeRequests.filter = this.txtFilter.value;
    //        if (this.expiredRequests) this.expiredRequests.filter = this.txtFilter.value;
    //        if (this.missingRequests) this.missingRequests.filter = this.txtFilter.value;

    //        this.UI.loaderCompleted(token);
    //    });
    //}

    public showDetails(id: string) {
        this.Dialog.open(T4_ServiceDialog, { data: { requestId: id } }).afterClosed().toPromise().then((x: any) => {

          this.datatable.update();
          this.activeIssues.update();
          this.urgentIssues.update();
          this.handledIssues.update();
          this.incompleteIssues.update();


          if (this.displayCompleted) {
                this.completedIssues.update();
            }
        });


      /*
       *  @ViewChild("newIssues") datatable: T4DatatableWidget;
          @ViewChild("urgentIssues") urgentIssues: T4DatatableWidge t;

          @ViewChild("handledIssues") handledIssues: T4DatatableWidget;
          @ViewChild("activeIssues") activeIssues: T4DatatableWidget;
          @ViewChild("completedIssues") completedIssues: T4DatatableWidget;
       *
       */ 
    }

    public export(data: T4DataSource) {
        data.export();
    }

    private assembleSearchString(item: RequestDetails): string {
        var searchStr = item.RequestNo + "|" + item.InsuranceId;
        if (item.RentalObject) {
            if (item.RentalObject.RentalLocation) {
                searchStr += item.RentalObject.RentalLocation!.Name + "|";
                searchStr += item.RentalObject.RentalLocation!.LocationCode + "|";
            }
            searchStr += item.RentalObject.Title + "|";
            searchStr += item.RentalObject.Alias + "|";
            searchStr += item.Status + "|";
            searchStr += item.Description + "|";
        }
        if (item.Tags) {
            for (var i = 0; i < item.Tags.length; i++) {
                searchStr += "|" + item.Tags[i];
            }
        }
        if (item.ServiceLocation) searchStr += item.ServiceLocation!.Name;

        return searchStr;
    }

    public tabChange(event) {
        if (event.index == 5) {
            this.displayCompleted = true;
        }
    }

    public filter(event) {
        this.datatable.txtFilter.setValue(event);
        this.datatable.txtFilter.setValue(event);
        this.activeIssues.txtFilter.setValue(event);
        this.urgentIssues.txtFilter.setValue(event);
        this.handledIssues.txtFilter.setValue(event);
        this.incompleteIssues.txtFilter.setValue(event);

        if (this.displayCompleted) {
            this.completedIssues.txtFilter.setValue(event);
        }
    }
}
